import React from 'react';

const weekdays = ['', '周一', '周二', '周三', '周四', '周五', '周六', '周日'];

export default function TimePricingDetails({ pricing }) {
  const rule = pricing?.time_pricing;
  if (!rule?.enabled) return null;
  const rows = [
    ['输入（未命中缓存）', 'input_price'],
    ['输出', 'output_price'],
    ['缓存命中输入', 'cache_read_price'],
    ['缓存写入', 'cache_creation_price'],
  ].flatMap(([name, field]) =>
    ['cny', 'usd']
      .filter((currency) => pricing[field]?.[currency] != null)
      .map((currency) => ({
        name,
        currency,
        peak: String(pricing[field][currency]),
        valley: rule.off_peak_prices?.[field]?.[currency] ?? '未配置',
      }))
  );
  return (
    <div style={{ margin: '12px 0' }}>
      <strong>峰谷计费（{rule.timezone}）</strong>
      {rule.peak_windows.map((window, index) => (
        <div key={index}>
          峰时：{window.weekdays.map((day) => weekdays[day]).join('、')}{' '}
          {window.start}–{window.end}
        </div>
      ))}
      <div>其余为谷时。以请求开始时间选择对应的峰价或谷价。</div>
      <table style={{ width: '100%', marginTop: 8 }}>
        <thead>
          <tr>
            <th>计费项</th>
            <th>峰价</th>
            <th>谷价</th>
            <th>单位</th>
          </tr>
        </thead>
        <tbody>
          {rows.map(({ name, currency, peak, valley }) => (
            <tr key={`${name}-${currency}`}>
              <td>{name}</td>
              <td>{peak}</td>
              <td>{valley}</td>
              <td>{currency === 'cny' ? '元' : '美元'}/百万 token</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
